<template>

  <div>
    <!-- Contenido solo visible para superadministradores -->
    <Encabeza>
 </Encabeza>
<h1>{{contadorarmamento}}</h1>
  <div class="text--primary pa-5">
    <v-row>
      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <router-link to="/ejercito">
            <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
              <v-img src="@/assets/ejto.png" alt="Imagen" class="img"></v-img>
            </v-card>
          </router-link>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <router-link to="/aerea">
            <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
              <v-img src="@/assets/aerea.png" alt="Imagen" class="img"></v-img>
            </v-card>
          </router-link>
        </v-hover>
      </v-col>

      <v-col cols="12" md="4">
        <v-hover v-slot="{ isHovering, props }">
          <router-link to="/armada">
            <v-card v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
              <v-img src="@/assets/ab.png" alt="Imagen" class="img"></v-img>
            </v-card>
          </router-link>
        </v-hover>
      </v-col>
    </v-row>
  </div> 
<!--contador Ejercito-->
<div class="text--primary pa-5">
  <v-row>
<v-col cols="12" md="4">
  <v-card color="blue-darken-2" v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
    <h5>  EJERCITO </h5>
   <h6>
  Armamento:{{ contadorarmamento  }}
  Cuchillos:{{ contadorcuchillo }}
  Sables:{{ contadorsable}}
</h6> 
</v-card>   
</v-col>

<!--contador Aerea-->
<v-col cols="12" md="4">
  <v-card color="blue-darken-2" v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
    <h5> AEREA </h5>
    <h6>
  Armamento:{{ contadorarmamentoaerea}}
  Cuchillos:{{ contadorcuchilloaerea }}
  Sables:{{ contadorsableaerea }}
</h6> 
  </v-card>          
</v-col>

<!--contador Armada-->
<v-col cols="12" md="4">
  <v-card color="blue-darken-2" v-bind="props" :elevation="isHovering ? 24 : 6" class="mx-auto pa-6">
    <h5> ARMADA </h5>
    <h6>
Armamento:{{ contadorarmamentoarmada }}
Cuchillos:{{ contadorcuchilloarmada }}
Sables:{{ contadorsablearmada }}
</h6> 
  </v-card>          
</v-col>
</v-row>
</div>

  <!-- filters -->
  <v-container fluid>
    <v-row>
      <v-col cols="4" sm="4" md="4">
        <v-checkbox label="Fuerzas" color="indigo" v-model="filter_fuerza.enabled" @change="filterDataFuerza()"
          hide-details></v-checkbox>

        <v-select label="Fuerzas" v-model="filter_fuerza.value" :disabled="!filter_fuerza.enabled"
          :items="['Ejercito', 'Fuerza Aerea bolivia', 'Armada boliviana']"
          @update:model-value="filterDataFuerza()" color="indigo"></v-select>

      </v-col>
      <v-col cols="4" sm="4" md="4">

        <v-checkbox label="Institucion" color="orange" value="institucion" hide-details
          v-model="filter_institucion.enabled" @change="filterDataInstitucion()"></v-checkbox>

        <v-select label="Institucion" v-model="filter_institucion.value" :disabled="!filter_institucion.enabled"
          :items="['Colegio militar del ejercito', 'Escuela militar de sargentos', 'Escuela militar de topografía', 'Escuela militar de música', 'Colegio Militar de Aviación', 'Politécnico Militar de Aeronáutica', 'Escuela Naval Militar', 'Escuela de Sargentos de la Armada']"
          @update:model-value="filterDataInstitucion()" color="orange"></v-select>
      </v-col>

      <v-col cols="4" sm="4" md="4">

        <v-checkbox label="Gestion" color="cyan" value="gestion" hide-details v-model="filter_gestion.enabled"
          @change="filterDataGestion()"></v-checkbox>

        <v-text-field label="fecha" v-model="filterGestionComputed" :disabled="!filter_gestion.enabled"
          append-icon="mdi-calendar" color="cyan" readonly @click:append="dialog_date = true"></v-text-field>

        <!-- dates -->
        <v-dialog persistent v-model="dialog_date" width="fit-content" transition="dialog-transition">
          <v-card class="alig-center justify-center">
            <v-card-title class="bg-cyan text-center">
              Seleccione el año
            </v-card-title>
            <v-date-picker-years v-model:display-date="filter_gestion.value" color="cyan" height="400">
            </v-date-picker-years>
            <v-card-actions class="justify-center">
              <v-btn @click="dialog_date = false" color="red" variant="elevated">Cancelar&nbsp;<v-icon
                  icon="mdi-close-circle-outline"></v-icon> </v-btn>
              <v-btn @click="dialog_date = false" color="cyan" variant="elevated">Aceptar &nbsp;<v-icon
                  icon="mdi-check"></v-icon> </v-btn>
            </v-card-actions>
          </v-card>

        </v-dialog>
        <!-- date -->

      </v-col>
    </v-row>

  </v-container>
  <v-container fluid>
    <v-card>
      <v-data-table :headers="headers" :items-per-page-options="items_per_page_options" :items="registros"
        :items-per-page-text="$t('$vuetify.dataTable.itemsPerPageText')"
        :no-data-text="$t('$vuetify.dataTable.noDataText')" :hover="true" :loading="loading_data_table"
        :fixed-header="true" :height="500" :multi-sort="true" :show-current-page="true">

      </v-data-table>

    </v-card>

  </v-container>

  <!-- filters -->
  </div>

</template>

<script>
import DotacionGeneral from '@/services/DotacionGeneral';
import ContadorCuEj from '@/services/Armablanca';
import { defineComponent } from 'vue';
import { VDataTable } from 'vuetify/labs/VDataTable';
import { VDatePickerYears } from 'vuetify/labs/VDatePicker';
import Encabeza from '@/components/EncabezadoPage.vue';




export default defineComponent({
  components: {
    VDataTable,
    VDatePickerYears,
    Encabeza,
   
  },

  data() {
    const contador = new ContadorCuEj();
    const loading_data_table = null;
    const filter_fuerza = { enabled: false, value: '' };
    const filter_institucion = { enabled: false, value: '' };
    const filter_gestion = { enabled: false, value: null };
    const registro_original = [];

    const contadorarmamento = ''
    const contadorcuchillo = ''
    const contadorsable= ''

    const items_per_page_options = [
      { value: 10, title: '10' },
      { value: 25, title: '25' },
      { value: 50, title: '50' },
      { value: 100, title: '100' },

    ]
    const headers = [
      { key: 'grado', title: 'Grado' },
      { key: 'nom', title: 'Nombre Completo', value: (item) => `${item.s_nombre} ${item.p_nombre} ${item.paterno} ${item.materno}` },
      // { key: 'complemento', title: 'Complemento' },
      // { key: 'marca', title: 'marca' },
      // { key: 'modelo', title: 'Modelo' },
      { key: 'pistola', title: 'Pistola' },
      { key: 'accesorio', title: 'Accesorio' },
      { key: 'gestion', title: 'Gestion' },
      { key: 'institucion', title: 'Institucion' },
      { key: 'fuerza', title: 'Fuerza' }
    ];
    const dotacion_general = new DotacionGeneral();
    const registros = [];
    const dialog_date = false;

    return {
      
      contadorarmamento,
      contadorcuchillo,
      contadorsable,
      contador,

      headers,
      dotacion_general,
      registros,
      loading_data_table,
      filter_fuerza,
      filter_institucion,
      filter_gestion,
      registro_original,
      dialog_date,
      items_per_page_options,
    }
  },
  mounted() {
    this.indexDB();
    this.contadorarmamentoejercito();
    this.contadorcuhcillo();
    this.contadorsableejercito();
  },
  computed: {
    filterGestionComputed() {
      // Crear un objeto de fecha a partir de la cadena
      var dateObject = new Date(this.filter_gestion.value);
      // Obtener el año de la fecha
      if (this.filter_gestion.value != null && this.dialog_date == false) {
        return dateObject.getFullYear();
      } else {
        return "";
      }

    }
  },

  watch: {
    filterGestionComputed(newDate) {
      if (newDate) {
        this.filterDataGestion();
      }
    }
  },


  methods: {

    async contadorarmamentoejercito(){
      //const respuesta = await this.contador.contadorarmamentogetejercito();
      //console.log('Respuesta del Contador',respuesta.records );
      this.change_table = "cyan";
      try {
        //const response = await this.obj_armas.listadearmas();
        const response = await this.contador.contadorarmamentogetejercito();
        this.contadorarmamento = response;
       this.contadorarmamento = response.data[0].contador;
        console.log('Respuesta del Contador',response );
      } catch (error) {
        console.error("Error al obtener los registros:", error);
      } finally {
        this.change_table = null;
      }
    },

    async contadorcuhcillo(){
      //const respuesta = await this.contador.contadorcuhillogetejercito();
      //console.log('Respuesta del Contador',respuesta.records );
      this.change_table = "cyan";
      try {
        //const response = await this.obj_armas.listadotacioncuchillo2();
        const response = await this.contador.contadorcuhillogetejercito();
        //this.contadorcuchillo = response;
        this.contadorcuchillo = response.data[0].contador;
        console.log('Respuesta del Contador',response );
      } catch (error) {
        console.error("Error al obtener los registros:", error);
      } finally {
        this.change_table = null;
      }
    },


    async contadorsableejercito(){
      //const respuesta = await this.contador.contadorsablegetejercito();
     // console.log('Respuesta del Contador',respuesta.records );
      this.change_table = "cyan";
      try {
        //const response = await this.obj_armas.listadotacioncuchillo2();
        const response = await this.contador.contadorsablegetejercito();
        this.contadorcsable = response;
       this.contadorsable = response.data[0].contador;
       console.log('Respuesta del Contador',response );
     } catch (error) {
        console.error("Error al obtener los registros:", error);
      } finally {
       this.change_table = null;
      }
    },

///////////////


    async indexDB() {
      this.loading_data_table = "orange";
      setTimeout(async () => {
        const respuesta = await this.dotacion_general.index();
        this.loading_data_table = null;
        if (respuesta.status) {
          this.registros = respuesta.records;
          this.registro_original = respuesta.records;
        }
      }, 1000);
    },

    filterDataFuerza() {
      if (this.filter_fuerza.enabled) {
        if (this.filter_fuerza.value != "") {
          this.registros = this.registro_original.filter((item) =>
            item.fuerza.toLowerCase().includes(this.filter_fuerza.value.toLowerCase())
          );
        }

      } else {
        this.resetDataTable();
        this.filter_fuerza.value = "";
      }
    },

    filterDataInstitucion() {
      if (this.filter_institucion.enabled) {
        if (this.filter_institucion.value != "") {
          this.registros = this.registro_original.filter((item) =>
            item.institucion.toLowerCase().includes(this.filter_institucion.value.toLowerCase())
          );
        }
      } else {
        this.resetDataTable();
        this.filter_institucion.value = "";
      }
    },

    filterDataGestion() {
      if (this.filter_gestion.enabled) {

        this.registros = this.registro_original.filter((item) =>
          item.gestion.includes(this.filterGestionComputed)
        );

      } else {
        this.filter_gestion.value = null;
        this.resetDataTable();
      }
    },

    resetDataTable() {
      if (!this.filter_fuerza.enabled && !this.filter_institucion.enabled && !this.filter_gestion.enabled) {
        this.registros = this.registro_original;
      }

    },


    saveYear(year) {
      console.log(year);

    }

  },//methods


});

</script>

<style>
.img {
  height: 150px;
}
</style>

